<section class="not-found-page d-flex align-items-center justify-content-center">
  <div class="not-found-page__backdrop"></div>

  <article class="not-found-card position-relative w-100">
    <div class="not-found-card__code">404</div>

    <div class="not-found-card__content text-center mx-auto">
      <div class="not-found-card__brand d-inline-flex align-items-center justify-content-center mb-3">
        <img src="assets/logo/bee.png" alt="BizzWeaver bee logo" />
      </div>

      <p class="not-found-card__eyebrow mb-2">Route not found</p>
      <h1 class="not-found-card__title mb-3">This page does not exist.</h1>
      <p class="not-found-card__description mb-4">
        The route you tried to open is not available in this environment or no longer exists.
      </p>

      <div class="d-flex flex-wrap justify-content-center gap-2">
        @if (isAuthenticated$ | async) {
          <a class="btn btn-primary" routerLink="/">Go to dashboard</a>
          <a class="btn btn-outline-secondary" routerLink="/websites">Open websites</a>
        } @else {
          <a class="btn btn-primary" routerLink="/login">Go to login</a>
          <a class="btn btn-outline-secondary" routerLink="/register">Create account</a>
        }
      </div>
    </div>
  </article>
</section>
